import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://iplay.sa.gov.tw/Home",
    target: "_blank",
    rel: "noreferrer noopenner"
  }, [
    /*#__PURE__*/_createElementVNode("small", null, " 來源：全國運動場館資訊網 ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.venueInfo)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (o, i) => {
      return (_openBlock(), _createElementBlock("li", { key: i }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.subheading)
        }, [
          _createElementVNode("h3", null, _toDisplayString(o.h3), 1)
        ], 2),
        (o.basic)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.basic)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(o.basic, (e, j) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                  _createElementVNode("span", null, _toDisplayString(e.title), 1),
                  (e.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: e.link,
                        target: "_blank",
                        rel: "noreferrer noopenner"
                      }, _toDisplayString(e.text), 9, _hoisted_1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(e.text ? e.text : '詳見官網'), 1))
                ], 64))
              }), 128))
            ], 2))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(o.text ? o.text : '詳見官網'), 1))
      ]))
    }), 128)),
    _hoisted_4
  ], 2))
}